export default "__VITE_ASSET__2226d620__"